/* eslint-disable max-len */
import { createSvgIcon } from "@mui/material/utils";

// Role badges: a purple disc with the role's shield in black. Guardian has a heart, Trustee a
// plus, Trust Admin a star, Patron a check, Pioneer (a Patron who redeemed a guardian invite
// code but hasn't minted a land yet) a flag and Global Trust Admin (a Trust Admin in the
// Governance GTA registry) two filled quadrants.

export const GuardianIcon = createSvgIcon(
  <svg width="180" height="180" viewBox="0 0 180 180" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M90.0001 177.19C41.9063 177.19 2.8125 138.096 2.8125 90.002C2.8125 41.9082 41.9063 2.81445 90.0001 2.81445C138.094 2.81445 177.188 41.9082 177.188 90.002C177.188 138.096 138.094 177.19 90.0001 177.19Z"
      fill="#BC92F8"
    />
    <path
      d="M90 5.625C136.575 5.625 174.375 43.425 174.375 90C174.375 136.575 136.575 174.375 90 174.375C43.425 174.375 5.625 136.575 5.625 90C5.625 43.425 43.425 5.625 90 5.625ZM90 0C40.3875 0 0 40.3875 0 90C0 139.613 40.3875 180 90 180C139.613 180 180 139.613 180 90C180 40.3875 139.613 0 90 0Z"
      fill="#BC92F8"
    />
    <path
      d="M125.344 59.9463V86.4346C125.344 97.7423 121.97 108.079 115.216 117.36C108.489 126.604 100.033 132.517 89.8447 135.04C79.6537 132.469 71.198 126.603 64.4717 117.36C57.717 108.079 54.3438 97.7908 54.3438 86.4346V59.9463L89.8438 46.0928L125.344 59.9463ZM97.9082 73.252C96.2504 73.252 94.6355 73.6094 93.1211 74.3789C91.8207 74.9975 90.7395 75.8094 89.8818 76.751C88.9786 75.8053 87.85 74.9897 86.5 74.3701C84.9625 73.6645 83.4027 73.252 81.7793 73.252C78.9575 73.252 76.4796 74.2811 74.4199 76.3721C72.3547 78.4197 71.3438 80.9394 71.3438 83.8008C71.3438 85.3077 71.5412 86.7298 71.9941 88.0596C72.4493 89.3958 73.2991 90.9086 74.6182 92.5967V92.5957C75.8848 94.2293 77.7249 96.2462 80.083 98.5938C82.4407 100.941 85.5652 103.921 89.5029 107.581L90.3438 108.362V107.386C97.9254 100.446 102.849 95.5398 105.025 92.6895C107.237 89.7928 108.344 86.8596 108.344 83.8496C108.344 80.837 107.33 78.4679 105.272 76.377C103.212 74.2829 100.732 73.252 97.9082 73.252Z"
      fill="black"
      stroke="black"
    />
  </svg>,
  "Guardian"
);

export const TrustAdminIcon = createSvgIcon(
  <svg width="180" height="180" viewBox="0 0 180 180" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M90.0001 177.19C41.9063 177.19 2.8125 138.096 2.8125 90.002C2.8125 41.9082 41.9063 2.81445 90.0001 2.81445C138.094 2.81445 177.188 41.9082 177.188 90.002C177.188 138.096 138.094 177.19 90.0001 177.19Z"
      fill="#BC92F8"
    />
    <path
      d="M90 5.625C136.575 5.625 174.375 43.425 174.375 90C174.375 136.575 136.575 174.375 90 174.375C43.425 174.375 5.625 136.575 5.625 90C5.625 43.425 43.425 5.625 90 5.625ZM90 0C40.3875 0 0 40.3875 0 90C0 139.613 40.3875 180 90 180C139.613 180 180 139.613 180 90C180 40.3875 139.613 0 90 0Z"
      fill="#BC92F8"
    />
    <path
      d="M77.4 106.2L90 96.75L102.375 106.2L97.65 90.9L110.25 81H94.95L90 65.7L85.05 81H69.75L82.125 90.9L77.4 106.2ZM90 135C79.575 132.375 70.9687 126.394 64.1812 117.056C57.3938 107.719 54 97.35 54 85.95V58.5L90 45L126 58.5V85.95C126 97.35 122.606 107.719 115.819 117.056C109.031 126.394 100.425 132.375 90 135Z"
      fill="black"
    />
  </svg>,
  "Trust Admin"
);

export const PatronIcon = createSvgIcon(
  <svg width="180" height="180" viewBox="0 0 180 180" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M90.0001 177.19C41.9063 177.19 2.8125 138.096 2.8125 90.002C2.8125 41.9082 41.9063 2.81445 90.0001 2.81445C138.094 2.81445 177.188 41.9082 177.188 90.002C177.188 138.096 138.094 177.19 90.0001 177.19Z"
      fill="#BC92F8"
    />
    <path
      d="M90 5.625C136.575 5.625 174.375 43.425 174.375 90C174.375 136.575 136.575 174.375 90 174.375C43.425 174.375 5.625 136.575 5.625 90C5.625 43.425 43.425 5.625 90 5.625ZM90 0C40.3875 0 0 40.3875 0 90C0 139.613 40.3875 180 90 180C139.613 180 180 139.613 180 90C180 40.3875 139.613 0 90 0Z"
      fill="#BC92F8"
    />
    <path
      d="M85.3333 106.784L110.067 81L104.467 75.1621L85.3333 95.1081L76 85.3784L70.4001 91.2162L85.8 107.27L85.3333 106.784ZM90 135C79.7333 132.568 71.3334 126.243 64.8 117C58.2667 107.757 55 97.054 55 85.8648V59.1081L90 45L125 59.1081V85.8648C125 97.054 121.733 107.757 115.2 117C108.667 126.243 100.267 132.081 90 135Z"
      fill="black"
    />
  </svg>,
  "Patron"
);

export const TrusteeIcon = createSvgIcon(
  <svg width="181" height="181" viewBox="0 0 181 181" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M90.402 177.974C42.0951 177.974 2.82812 138.707 2.82812 90.4C2.82812 42.0931 42.0951 2.82617 90.402 2.82617C138.709 2.82617 177.976 42.0931 177.976 90.4C177.976 138.707 138.709 177.974 90.402 177.974Z"
      fill="#BC92F8"
    />
    <path
      d="M90.3988 5.64992C137.18 5.64992 175.148 43.6174 175.148 90.3988C175.148 137.18 137.18 175.148 90.3988 175.148C43.6174 175.148 5.64992 137.18 5.64992 90.3988C5.64992 43.6174 43.6174 5.64992 90.3988 5.64992ZM90.3988 0C40.5665 0 0 40.5664 0 90.3988C0 140.231 40.5665 180.798 90.3988 180.798C140.231 180.798 180.798 140.231 180.798 90.3988C180.798 40.5664 140.231 0 90.3988 0Z"
      fill="#BC92F8"
    />
    <path
      d="M85.1198 105.075H96.8817V93.9064H108.644V82.7376H96.8817V71.5689H85.1198V82.7376H73.3573V93.9064H85.1198V105.075ZM91.0008 135.764C79.9939 133.202 70.8758 127.259 63.6458 117.986C56.4158 108.713 52.8008 98.3636 52.8008 87.0412V60.4002L91.0008 46.4648L129.201 60.4002V87.0412C129.201 98.3636 125.586 108.713 118.356 117.986C111.126 127.259 102.008 133.202 91.0008 135.764Z"
      fill="black"
    />
  </svg>,
  "Trustee"
);

// Pioneer (shield with a flag) and Global Trust Admin (shield with two filled quadrants) come
// from the Figma role icons (nodes 3014-4185 and 3014-4184), which are drawn in a 32 × 32 frame
// rather than the 180 × 180 one above. The paths are Figma's, recoloured to the badge scheme:
// purple disc, black shield, glyph cut out of the shield. The Figma draws the Pioneer flag as a
// black shape laid over a white shield; here the two share one evenodd path so the flag is a hole,
// like the other badges.
export const PioneerIcon = createSvgIcon(
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 0C7.18 0 0 7.18 0 16C0 24.82 7.18 32 16 32C24.82 32 32 24.82 32 16C32 7.18 24.82 0 16 0Z"
      fill="#BC92F8"
    />
    <path
      fillRule="evenodd"
      d="M15.96 25.23C13.8 24.7 12.0098 23.48 10.5898 21.56C9.16984 19.64 8.45996 17.51 8.45996 15.16V9.65002L15.96 6.76001L23.46 9.65002V15.16C23.46 17.5 22.7501 19.64 21.3301 21.56C19.9101 23.48 18.12 24.71 15.96 25.23ZM13.25 19.39H14.71V15.88H19.8301L18.1899 13.68L19.8301 11.49H13.25V19.39Z"
      fill="black"
    />
  </svg>,
  "Pioneer"
);

export const GlobalTrustAdminIcon = createSvgIcon(
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 0C7.18 0 0 7.18 0 16C0 24.82 7.18 32 16 32C24.82 32 32 24.82 32 16C32 7.18 24.82 0 16 0Z"
      fill="#BC92F8"
    />
    <path
      d="M16 24.67C13.97 24.16 12.3 22.99 11 21.14C9.7 19.29 9.04004 17.27 9.04004 15.06V9.89001L16 7.28003L22.96 9.89001V15.06C22.96 17.26 22.31 19.29 21 21.14C19.69 22.99 18.03 24.17 16 24.67ZM16 23.32C17.54 22.81 18.8101 21.88 19.8101 20.53C20.8201 19.18 21.4101 17.66 21.5801 15.98H15.9902V8.70001L10.3403 10.81V15.07C10.3403 15.24 10.3401 15.39 10.3501 15.52C10.3601 15.65 10.3804 15.8001 10.4004 15.9901H15.9902V23.34L16 23.32Z"
      fill="black"
    />
  </svg>,
  "Global Trust Admin"
);

// The Global Trust Admin shield on its own, without the purple disc, painted in currentColor. For
// inline labels (e.g. the transaction feed) that sit beside monochrome MUI icons. The viewBox is
// cropped to the shield so it fills the icon box like they do.
export const GlobalTrustAdminMonoIcon = createSvgIcon(
  <svg width="20" height="20" viewBox="6 6 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16 24.67C13.97 24.16 12.3 22.99 11 21.14C9.7 19.29 9.04004 17.27 9.04004 15.06V9.89001L16 7.28003L22.96 9.89001V15.06C22.96 17.26 22.31 19.29 21 21.14C19.69 22.99 18.03 24.17 16 24.67ZM16 23.32C17.54 22.81 18.8101 21.88 19.8101 20.53C20.8201 19.18 21.4101 17.66 21.5801 15.98H15.9902V8.70001L10.3403 10.81V15.07C10.3403 15.24 10.3401 15.39 10.3501 15.52C10.3601 15.65 10.3804 15.8001 10.4004 15.9901H15.9902V23.34L16 23.32Z"
      fill="currentColor"
    />
  </svg>,
  "Global Trust Admin"
);
